export default __webpack_public_path__ + "static/media/checkTeal.e0f8cb92.svg";